var TESNAV = TESNAV || {};

// fire on document ready as this script might be called from <head>
jQuery(document).ready(function() {

  var avatarImage = function (element, imageUrl) {
    element.onerror = function() {
      element.src = TES.siteAssetsCDN + 'img/avatar_small.jpg';
    };
    element.src = imageUrl;
  };

  TESNAV.$container = jQuery('.new-header-wrapper .nav');

  if (!window || !window.location || !window.location.host) {
    return;
  }

  if (!/.+.tesforteachers.com/.test(window.location.host)) {
    TESNAV.panelToggle();
    TESNAV.menuToggle();
    TESNAV.requestProfile();
  } else {
    //Added for the US version only
    if (typeof Cookies !== 'undefined' && !Cookies.get('TESCookieV2')) {
      TESNAV.$container.find('.js-profile').addClass('loaded');
      return;
    }

    var data = JSON.parse(atob(Cookies.get('TESCookieV2').split('.')[1]));

    if (data) {
      data.displayName = data.firstName + ' ' + data.lastName;
      data.avatarSmall = [TES.imageCDN, Cookies.get('TESCookieUser'), 'small'].join('/') + '.jpg';
      TESNAV.$container.find('.js-profile').html(
        TES.templates['header-profile-v3-us'](data)
      );
      $(".not_authenticated").removeClass("not_authenticated");
      avatarImage(document.getElementById('avatarImage'), data.avatarSmall);
    }

    TESNAV.$container.find('.js-profile').addClass('loaded');
  }
});
